/**
 * `crypto.randomUUID` exists only in secure contexts (https / localhost). An
 * operator console served over plain http on a LAN IP — an ops-room reality, and
 * the standard dev setup for driving the UI from another machine — is NOT a
 * secure context: every write that minted its Idempotency-Key with
 * `crypto.randomUUID()` threw a TypeError before the request left the browser
 * (the button "did nothing"). `getRandomValues` IS available in insecure
 * contexts, so mint a spec-compliant v4 from it. ONE helper for every caller —
 * never call `crypto.randomUUID()` directly.
 */
export function uuidV4(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const b = crypto.getRandomValues(new Uint8Array(16));
  b[6] = ((b[6] ?? 0) & 0x0f) | 0x40; // version 4
  b[8] = ((b[8] ?? 0) & 0x3f) | 0x80; // RFC 4122 variant
  const h = Array.from(b, (x) => x.toString(16).padStart(2, '0'));
  return `${h[0]}${h[1]}${h[2]}${h[3]}-${h[4]}${h[5]}-${h[6]}${h[7]}-${h[8]}${h[9]}-${h[10]}${h[11]}${h[12]}${h[13]}${h[14]}${h[15]}`;
}

/** A fresh Idempotency-Key for one operator write (dedupes a double-click at the domain). */
export function newIdempotencyKey(): string {
  return uuidV4();
}
